export const blockExplorerUrl = 'https://polygonscan.com/'
export const openseaHref = 'https://opensea.io/collection/maups'
export const discordHref = 'https://discord.gg'
export const revealedImageURL =
  'https://gateway.pinata.cloud/ipfs/QmYDQ9AnmSjudioad953Myzu46Zka8ZaahLaC3xNAhMUdy/'
export const hiddenImageURL =
  'https://gateway.pinata.cloud/ipfs/QmZGAnyS23nYx6urmPk1q6vdQ2fSPKqyjfgMuwWc65GRyA'
